import { createContext, useContext, useEffect, useRef, useId } from "react"
import PropTypes from "prop-types"
import { DEFAULT_CONFIG } from "./config"

export const Publicity = ({ name }) => {
  const ad = useAd(name)

  if (!ad) return null

  return <div style={ad.style} id={ad.id} />
}

Publicity.propTypes = {
  name: PropTypes.oneOf(["vertical", "horizontal", "horizontalMobile", "login"])
    .isRequired,
}

const useAd = (name) => {
  const publicityConfig = usePublicityConfig()
  const config = publicityConfig[name]
  const slotRef = useRef(null)
  const id = useId()

  useEffect(() => {
    if (!config) {
      return
    }

    const googletag = window.googletag

    if (!googletag) {
      console.warn(
        "Tried to render an ad but google tag is not initialized. Skipping.",
      )
      return
    }

    if (!config) {
      console.warn(
        `Tried to render the ${name} ad, but couldn't found associated configuration. Skipping.`,
      )
      return
    }

    googletag.cmd.push(function () {
      slotRef.current = googletag
        .defineSlot(config.path, config.size, `${id}${config.id}`)
        .addService(googletag.pubads())
      googletag.pubads().enableSingleRequest()
      googletag.enableServices()
    })

    googletag.cmd.push(function () {
      googletag.display(`${id}${config.id}`)
    })

    return () => {
      if (!slotRef.current) {
        return
      }

      googletag.cmd.push(function () {
        googletag.destroySlots([slotRef.current])
      })
    }
  }, [config, name, id])

  if (!config) return null

  const style = {
    minWidth: config.size[0],
    minHeight: config.size[1],
  }

  return { style, id: `${id}${config.id}` }
}

const PublicityContext = createContext()

export const PublicityConfigProvider = (props) => {
  return (
    <PublicityContext.Provider value={props.config}>
      {props.children}
    </PublicityContext.Provider>
  )
}

const usePublicityConfig = () => {
  const ctx = useContext(PublicityContext)

  return { ...DEFAULT_CONFIG, ...ctx }
}
